<div class="card"
     [ngClass]="{'h-100': height === 'full' || height === 'full-inner'}">
  <div class="card-header d-flex align-items-center justify-content-between">
    <h2 class="mb-0" *ngIf="header">
      <ng-container *ngIf="name">{{ name }}</ng-container>
      <ng-content select="[card][name]"></ng-content>
    </h2>
    <div class="ml-auto d-flex mx-n2">
      <button class="btn-link btn-square text-secondary mx-2" *ngIf="cardService.refresher.visible"
              (click)="cardService.updateHook()">
        <icon-refresh></icon-refresh>
        <span class="sr-only">Refresh</span>
      </button>
      <div class="mx-2" [hidden]="!buttons.children.length" #buttons>
        <ng-content select="[card][button]"></ng-content>
      </div>
      <div class="mx-2" *ngIf="cardService.portals.actions">
        <ng-container [cdkPortalHost]="cardService.portals.actions"></ng-container>
      </div>
    </div>
  </div>
  <hr *ngIf="divider">
  <div class="card-body" [ngClass]="{'h-flex-full': height === 'full-inner'}">
<!--<<<<<<< HEAD-->
    <ng-content select="[card][controls]"></ng-content>
<!--    <div class="card-content" [ngClass]="{'h-flex-full': height === 'full-inner'}">-->
<!--      <ng-container *ngIf="!empty && !error">-->
<!--        <div class="position-relative card-out-scroll"-->
<!--             [ngClass]="{'ps': scrollbar, 'h-flex-full': height === 'full-inner'}"-->
<!--             [disabled]="!scrollbar" perfectScrollbar>-->
<!--          <div class="card-in-scroll"-->
<!--               [ngClass]="{'h-flex-full': height === 'full-inner'}">-->
<!--            <ng-content select="[card][content]"></ng-content>-->
<!--          </div>-->
<!--        </div>-->
<!--      </ng-container>-->
<!--=======-->
    <ng-content select="[card][content]"></ng-content>
<!--&gt;>>>>>> origin/fixedTableHeaders-->

    <!--    <div class="card-content" [ngClass]="{'h-flex-full': height === 'full-inner'}">-->
<!--      <ng-container *ngIf="!empty && !error">-->
<!--        <div class="position-relative card-out-scroll"-->
<!--             [ngClass]="{'ps': scrollbar, 'h-flex-full': height === 'full-inner'}"-->
<!--             [disabled]="!scrollbar" perfectScrollbar>-->
<!--          <div class="card-in-scroll"-->
<!--               [ngClass]="{'h-flex-full': height === 'full-inner'}">-->
<!--            <ng-content select="[card][content]"></ng-content>-->
<!--          </div>-->
<!--        </div>-->
<!--      </ng-container>-->

<!--      <empty-data *ngIf="empty"></empty-data>-->
<!--      <error-data *ngIf="error"></error-data>-->
<!--    </div>-->
  </div>

  <div class="card-footer"
       [hidden]="!footerEl.children.length" #footerEl>
    <ng-content select="[card][footer]"></ng-content>

    <ng-container *ngIf="cardService.portals.footer">
      <ng-container [cdkPortalHost]="cardService.portals.footer"></ng-container>
    </ng-container>
  </div>
</div>
